// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FlagFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from flag-filled.svg
 */
export default function FlagFilledIcon(props: FlagFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FlagFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M2 1a1 1 0 0 1 .883-.993L3 0h12c.852 0 1.297.986.783 1.623l-.076.084L12.415 5l3.292 3.293c.575.575.253 1.523-.485 1.684l-.108.017L15 10H4v5a1 1 0 0 1-1.993.117L2 15z"
        />
      </g>
    </svg>
  );
}
